import styled from "styled-components";
import { ReactComponent as CheckSVG } from 'assets/icons/check.svg'
import Button from "ui/Button";

export const InfoContainer = styled.article`
  display: flex;
  gap: 24px;
  margin: 0 ${({ theme }) => theme.old.sizes.sidesMargin.large};
  margin-bottom: 40px;

  ${({ theme }) => theme.old.breakpoints.isMobileBig} {
    margin: 0 ${({ theme }) => theme.old.sizes.sidesMargin.small};
    margin-bottom: 40px;
    flex-direction: column;
  }
`

export const CoverWrapper = styled.div`
  width: 100%;
  max-width: 560px;
  display: grid;

  ${({ theme }) => theme.old.breakpoints.isMobileBig} {
    max-width: unset;
  }
`

export const Metadata = styled.div`
  width: 100%;
  max-width: 460px;
  min-width: 250px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${({ theme }) => theme.old.breakpoints.isMobileBig} {
    max-width: unset;
    max-width: 760px;

  }
`

export const Check = styled(CheckSVG)`
  background-color: ${({ theme }) => theme.old.colors.gray[50]};
  color: ${({ theme }) => theme.old.colors.gray[190]};
  border-radius: 100%;
  padding: 3px;
  height: 14px;
  width: 14px;
`

export const CTA = styled(Button)`
  font-size: ${({ theme }) => theme.old.fonts.size.normal};
  line-height: ${({ theme }) => theme.old.fonts.size.large};
  color: white;
`